module.exports = __webpack_public_path__ + "images/company-branding-1e87362827ec5c9b04b4ec7b2474036a.jpg";